"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var environment_1 = require("../core/environment");
var network_1 = require("./network");
var transports_1 = require("./transports");
function aWebEnvironment(opts) {
    var network = new network_1.default();
    var transportsManager = transports_1.default({ baseUrl: opts.url });
    return new environment_1.default({ transportsManager: transportsManager, network: network });
}
exports.default = aWebEnvironment;
//# sourceMappingURL=environment.js.map